class costCenter {
    constructor(
      id,
      name
      ) {
      this.id = id;
      this.name = name;

    }
    static fromJson({
      csCostoId,
      nombre
    }) {
      return new costCenter(
        csCostoId,
        nombre
      );
    }
  }
  export default costCenter;
  